<template>
  <div>
    <b-modal
      id="vendor-locations-viewer"
      ok-only
      :title="`${locations.length == 0 ? 'No locations for this vendor': ''}`"
    >
      <locations-viewer :locations="locations" />
    </b-modal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import LocationsViewer from './LocationsViewer.vue'

export default {
  components: {
    BModal,
    LocationsViewer,
  },
  props: {
    locations: {
      type: Array,
      required: true,
    },
  },
}
</script>
